<template>
  <div :class="$style['invited-customer-message']">
    <pt-sub-title-tab :data="inviteCustomerTab" v-model="selectInviteTab" v-loading="totalLoading"></pt-sub-title-tab>
    <wt-paged-table :on-request-data="getTableDataFunction" :total-size="total_number" :page-size="pageSize" ref="table"
                    v-loading="detailLoading||tableLoading">
      <wt-table :list="tableData" :labels="tableLables">
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.id||scope.row.mallUserId" @click="getCustomerDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </wt-table>
    </wt-paged-table>
  </div>
</template>
<script>
import { inviteCustomerTab, inviteFamilyTableLabels, invitedCustomerLabels, inviteOldBringNewTableLabels } from './customer-detail-option'
// import {}
export default {
  data () {
    return {
      totalNumber: 0,
      pageSize: 10,
      customerTableData: [],
      user_login: this.userLogin,
      tableLoading: false,
      detailLoading: false,
      inviteCustomerTab: inviteCustomerTab,
      selectInviteTab: 'customer',
      inviteFamilyTableLabels: inviteFamilyTableLabels,
      invitedCustomerLabels: invitedCustomerLabels,
      familyTotalNumber: 0,
      familyTableData: [],
      inviteOldBringNewTableLabels: inviteOldBringNewTableLabels,
      inviteOldBringNewTotalNumber: 0,
      inviteStatistics: {},
      oldBringNewTableData: [],
      totalLoading: false
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  computed: {
    tableLables () {
      return this.selectInviteTab === 'family' ? this.inviteFamilyTableLabels
        : (this.selectInviteTab === 'oldBringNew' ? this.inviteOldBringNewTableLabels : this.invitedCustomerLabels)
    },
    total_number () {
      return this.selectInviteTab === 'family' ? this.familyTotalNumber
        : (this.selectInviteTab === 'oldBringNew' ? this.inviteOldBringNewTotalNumber : this.totalNumber)
    },
    getTableDataFunction () {
      return this.selectInviteTab === 'family' ? this.familyListTable
        : (this.selectInviteTab === 'oldBringNew' ? this.oldBringNewListTable : this.getTableData)
    },
    tableData () {
      return this.selectInviteTab === 'family' ? this.familyTableData
        : (this.selectInviteTab === 'oldBringNew' ? this.oldBringNewTableData : this.customerTableData)
    }
  },
  watch: {
    inviteStatistics: {
      handler: function (val) {
        this.inviteCustomerTab.forEach(item => {
          if (item.value === 'oldBringNew') {
            item.label = '脐荐康 (' + val.customerBringNewTotal + '人）'
          } else if (item.value === 'family') {
            item.label = '已确定家人（' + val.invitationFamilyMemberTotal + '人）'
          } else {
            item.label = '已邀请用户（' + val.invitationUserTotal + '人）'
          }
        })
      },
      deep: true
    },
    selectInviteTab (val) {
      if (val === 'family') {
        this.familyListTable(0)
      } else if (val === 'oldBringNew') {
        this.oldBringNewListTable(0)
      } else {
        this.getTableData(0)
      }
    }
  },
  methods: {
    getCustomerDetail (row) {
      if (this.selectInviteTab === 'family') {
        this.$emit('getCustomerDetail', row.mallUserId)
      } else if (this.selectInviteTab === 'oldBringNew') {
        this.$emit('getCustomerDetail', row.newCustomer && row.newCustomer.userId)
      } else {
        this.$emit('getCustomerDetail', row.id)
      }
    },
    getTableData (page, next) {
      let data = {
        pageable: {
          page: page,
          size: this.pageSize
        },
        example: this.user_login
      }
      if (!next) {
        this.tableLoading = true
      }
      this.$store.dispatch('pageInvitationUsers', data).then(res => {
        this.customerTableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        this.$message.error(err || '获取已邀请用户列表失败')
      })
    },
    mallUserDetail () {
      this.tableLoading = true
      this.$store.dispatch('getUserDetailAddress', this.id).then(res => {
        this.user_login = res.userLogin
        this.getTableData(0)
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        this.$message.error(err || '获取用户详情失败')
      })
    },
    familyListTable (page, next) {
      let data = {
        pageable: {
          page: page,
          size: this.pageSize
        },
        userLogin: this.user_login
      }
      if (!next) {
        this.tableLoading = true
      }
      this.$store.dispatch('familyListTable', data).then(res => {
        this.tableLoading = false
        this.familyTotalNumber = res.totalNumber
        this.familyTableData = res.data
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.tableLoading = false
        this.$message.error(err || '获取已邀请家人失败')
      })
    },
    oldBringNewListTable (page, next) {
      let data = {
        pageable: {
          page: page,
          size: this.pageSize
        },
        userLogin: this.user_login
      }
      if (!next) {
        this.tableLoading = true
      }
      this.$store.dispatch('inviteCustomerBringNew', data).then(res => {
        this.tableLoading = false
        this.inviteOldBringNewTotalNumber = res.totalNumber
        this.oldBringNewTableData = res.data
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.tableLoading = false
        this.$message.error(err || '获取脐荐康列表失败')
      })
    },
    inviteCustomerTotal () {
      this.totalLoading = true
      this.$store.dispatch('inviteCustomerTotal', this.user_login).then(res => {
        this.totalLoading = false
        this.inviteStatistics = res
      }).catch(err => {
        this.totalLoading = false
        this.$message.error(err || '获取统计数据失败')
      })
    }
  },
  created () {
    this.inviteCustomerTotal()
    this.mallUserDetail()
  }
}
</script>
<style  module lang="less">
.invited-customer-message{

}
</style>
